import ResponsiveHeader from '@/components/ResponsiveHeader';
import { Stack } from 'expo-router';

export default function BookmarksLayout() {
  return (
    <Stack
      screenOptions={{
        animation: 'default',
        header: ({ navigation, options, back }) => (
          <ResponsiveHeader
            title={(options.title as string) || ''}
            showBack={!!back}
            showBookmark={false}
            onBack={() => navigation.goBack()}
            navItems={[
              { label: 'Explore', href: '/explore' },
              { label: 'Live', href: '/live' },
              { label: 'The Hang', href: '/library' },
            ]}
          />
        ),
      }}
    >
      <Stack.Screen name="index" options={{ title: '' }} />
    </Stack>
  );
}
